import React from 'react';

export default function StatusBadge({ status, labels }) {
  return (
    <span className={`dash-badge dash-badge--${status}`}>
      {labels?.[status] || status}
    </span>
  );
}
